export default __webpack_public_path__ + "static/media/img4.274e1cc0.jpg";